import React from "react";
import Button from "../../../Button/Button";
import PerformanceMobility from "./PerformanceMobility/PerformanceMobility";
import MassageTherapy from "./MassageTherapy/MassageTherapy";
import BodyTransformation from "./BodyTransformation/BodyTransformation";
import CuppingTherapy from "./CuppingTherapy/CuppingTherapy";
import Acupuncture from "./Acupuncture/Acupuncture";
import Physiotherapy from "./Physiotherapy/Physiotherapy";
import ManipulativeTherapy from "./ManipulativeTherapy/ManipulativeTherapy";
import AdvancedElectroMuscular from "./AdvancedElectroMuscular/AdvancedElectroMuscular";

const TreatmentOptions = ({
  handleNextStep,
  handleBackStep,
  subActiveStep,
  massageCardsData,
  setMassageCardsData,
  performanceData,
  setPerformanceData,
  bodyTransformationData,
  setBodyTransformationData,
  handleIncrementSession,
  handleDecrementSession,
  cuppingTherapyData,
  setCuppingTherapydata,
  advancedElectroMuscularData,
  setAdvancedElectroMuscularData,
  manipulativeTherapyData,
  setManipulativeTherapyData,
  physiotherapyData,
  setPhysiotherapyData,
  acupunctureData,
  setAcupunctureData,
  handlePayNow,
}) => {
  const activeTreatmentOption = {
    0: "Massage Therapy",
    1: "Physiotherapy",
    2: "Acupuncture",
    3: "Performance Mobility Therapy",
    4: "Body Transformation",
    5: "Cupping Therapy",
    6: "Advanced Electro Muscular Therapy",
    7: "Manipulative Medicine",
  };
  const treatmentOption = {
    0: (
      <MassageTherapy
        massageCardsData={massageCardsData}
        setMassageCardsData={setMassageCardsData}
      />
    ),
    1: (
      <Physiotherapy
        physiotherapyData={physiotherapyData}
        setPhysiotherapyData={setPhysiotherapyData}
      />
    ),
    2: (
      <Acupuncture
        acupunctureData={acupunctureData}
        setAcupunctureData={setAcupunctureData}
      />
    ),
    3: (
      <PerformanceMobility
        performanceData={performanceData}
        setPerformanceData={setPerformanceData}
      />
    ),
    4: (
      <BodyTransformation
        bodyTransformationData={bodyTransformationData}
        setBodyTransformationData={setBodyTransformationData}
        handleIncrementSession={handleIncrementSession}
        handleDecrementSession={handleDecrementSession}
      />
    ),
    5: (
      <CuppingTherapy
        cuppingTherapyData={cuppingTherapyData}
        setCuppingTherapydata={setCuppingTherapydata}
      />
    ),
    6: (
      <AdvancedElectroMuscular
        advancedElectroMuscularData={advancedElectroMuscularData}
        setAdvancedElectroMuscularData={setAdvancedElectroMuscularData}
      />
    ),
    7: (
      <ManipulativeTherapy
        manipulativeTherapyData={manipulativeTherapyData}
        setManipulativeTherapyData={setManipulativeTherapyData}
      />
    ),
  };
  return (
    <>
      <p className="font-font-Titillium font-light text-[18px] text-[#262626] text-center leading-[27px] tracking-[0.0313em]">
        You have the flexibility to choose from a vast list of services and
        customize the plan to suit your needs
      </p>
      <p className="font-font-Titillium font-normal text-[22px] text-[#262626] text-center leading-[33px] tracking-[0.0094em] mt-16 mb-4">
        Choose your preferred type of{" "}
        <strong>{activeTreatmentOption[subActiveStep]}</strong>
        {Object?.values(activeTreatmentOption)
          ?.slice(5, 8)
          ?.includes(activeTreatmentOption[subActiveStep])
          ? " treatment :"
          : ":"}
      </p>
      {treatmentOption[subActiveStep]}
      <div className="grid grid-cols-1 sm:grid-cols-6 gap-6 justify-center items-center mt-10 sm:mt-20 md:mt-40">
        <Button
          name={`< BACK`}
          background="#FFFFFF"
          classNames="uppercase bg-none border border-solid border-[#141414] w-[193px]"
          divStyle="col-span-2 justify-center sm:justify-end"
          onClickHandler={handleBackStep}
        />
        <Button
          name={`Continue >`}
          classNames="uppercase hover:bg-[#FFC53D] w-[193px]"
          divStyle="col-span-2 justify-center sm:justify-start"
          onClickHandler={handleNextStep}
        />
        <Button
          name={`Pay Now`}
          classNames="uppercase hover:bg-[#FFC53D] w-[193px]"
          divStyle="col-span-2 justify-center sm:justify-start"
          onClickHandler={handlePayNow}
        />
      </div>
    </>
  );
};

export default TreatmentOptions;
